import { fontStyles } from 'styles/theme';
import styled from '@emotion/styled';

export default function AndContainer(): JSX.Element {
  return <Container>AND</Container>;
}

const Container = styled.span({
  fontSize: fontStyles.sizes.xs,
  color: fontStyles.colors.tertiary,
});
